exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".console-setting-wrap[data-v-3d40862f]{padding:0;border-radius:2px}.console-setting-wrap[data-v-3d40862f] .el-tabs__active-bar{background-color:#f10e0e}.console-setting-wrap[data-v-3d40862f] .el-tabs__header{margin:0;background:#fff}.console-setting-wrap[data-v-3d40862f] .el-tabs__content{padding:0}.console-setting-wrap[data-v-3d40862f] .el-tabs__item{color:#290202}.console-setting-wrap[data-v-3d40862f] .el-tabs__item.is-active{color:#f10e0e;font-weight:700}.console-setting-wrap[data-v-3d40862f] .el-tabs__item span{padding:0 15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d40862f","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/console/setting.vue
// module id = Glyy
// module chunks = 7